module.exports = __webpack_public_path__ + "images/emoji/cyclone.932b30d31225a8dfe3e6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cyclone.png
// module id = nI2e
// module chunks = 2